module.exports = __webpack_public_path__ + "static/media/reference-icon.cd0ee6a9.svg";